import React, { useEffect, useContext, useState } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin, { Draggable } from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import bootstrapPlugin from '@fullcalendar/bootstrap';
import { AppSettings } from './../../config/app-settings.js';
import DateTime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';

function Calendar() {
	const context = useContext(AppSettings);
	const plugins = [ dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin, bootstrapPlugin ];
	const headerToolbar = {
		left: 'dayGridMonth,timeGridWeek,timeGridDay',
		center: 'title',
		right: 'prev,next today'
	};
	const buttonText = {
		today:    'Today',
		month:    'Month',
		week:     'Week',
		day:      'Day'
	};
	const views = {
		timeGrid: {
			eventLimit: 6
		}
	};
	const [events, setEvents] = useState();
	
	useEffect(() => {
		context.setAppContentFullHeight(true);
		context.setAppContentClass('p-0');
		
		var containerEl = document.getElementById('external-events');
		new Draggable(containerEl, {
			itemSelector: '.fc-event-link',
			eventData: function(eventEl) {
				return {
					title: eventEl.innerText,
					color: eventEl.getAttribute('data-color')
				};
			}
		});
		
		var themeRgb = (getComputedStyle(document.body).getPropertyValue('--bs-theme-rgb')).trim();
		var blueRgb = (getComputedStyle(document.body).getPropertyValue('--bs-blue-rgb')).trim();
		var pinkRgb = (getComputedStyle(document.body).getPropertyValue('--bs-pink-rgb')).trim();
		var indigoRgb = (getComputedStyle(document.body).getPropertyValue('--bs-indigo-rgb')).trim();
		var greenRgb = (getComputedStyle(document.body).getPropertyValue('--bs-green-rgb')).trim();
		var redRgb = (getComputedStyle(document.body).getPropertyValue('--bs-red-rgb')).trim();
		var orangeRgb = (getComputedStyle(document.body).getPropertyValue('--bs-orange-rgb')).trim();
		
		var date = new Date();
		var year = date.getFullYear();
		var month = date.getMonth() + 1;
				month = (month < 10) ? '0' + month : month;
		
		setEvents([{
			title: 'Trip to London',
			start: year + '-'+ month +'-01',
			end: year + '-'+ month +'-05',
			color: 'rgba(' + themeRgb + ', .35)'
		},{
			title: 'Meet with Sean Ngu',
			start: year + '-'+ month +'-02T06:00:00',
			color: 'rgba(' + blueRgb + ', .35)'
		},{
			title: 'Mobile Apps Brainstorming',
			start: year + '-'+ month +'-10',
			end: year + '-'+ month +'-12',
			color: 'rgba(' + pinkRgb + ', .35)'
		},{
			title: 'Stonehenge, Windsor Castle, Oxford',
			start: year + '-'+ month +'-05T08:45:00',
			end: year + '-'+ month +'-06T18:00',
			color: 'rgba(' + indigoRgb + ', .35)'
		},{
			title: 'Paris Trip',
			start: year + '-'+ month +'-12',
			end: year + '-'+ month +'-16'
		},{
			title: 'Domain name due',
			start: year + '-'+ month +'-15',
			end: year + '-'+ month +'-15',
			color: 'rgba(' + blueRgb + ', .35)'
		},{
			title: 'Cambridge Trip',
			start: year + '-'+ month +'-19',
			end: year + '-'+ month +'-19'
		},{
			title: 'Visit Apple Company',
			start: year + '-'+ month +'-22T05:00:00',
			color: 'rgba(' + greenRgb + ', .35)'
		},{
			title: 'Exercise Class',
			start: year + '-'+ month +'-22T07:30:00',
			color: 'rgba(' + orangeRgb + ', .35)'
		},{
			title: 'Live Recording',
			start: year + '-'+ month +'-22T03:00:00',
			color: 'rgba(' + blueRgb + ', .35)'
		},{
			title: 'Announcement',
			start: year + '-'+ month +'-22T15:00:00',
			color: 'rgba(' + redRgb + ', .35)'
		},{
			title: 'Dinner',
			start: year + '-'+ month +'-22T18:00:00'
		},{
			title: 'New Android App Discussion',
			start: year + '-'+ month +'-25T08:00:00',
			end: year + '-'+ month +'-25T10:00:00',
			color: 'rgba(' + redRgb + ', .35)'
		},{
			title: 'Marketing Plan Presentation',
			start: year + '-'+ month +'-25T12:00:00',
			end: year + '-'+ month +'-25T14:00:00',
			color: 'rgba(' + blueRgb + ', .35)'
		},{
			title: 'Chase due',
			start: year + '-'+ month +'-26T12:00:00',
			color: 'rgba(' + orangeRgb + ', .35)'
		},{
			title: 'Heartguard',
			start: year + '-'+ month +'-26T08:00:00',
			color: 'rgba(' + orangeRgb + ', .35)'
		},{
			title: 'Lunch with Richard',
			start: year + '-'+ month +'-28T14:00:00',
			color: 'rgba(' + blueRgb + ', .35)'
		},{
			title: 'Web Hosting due',
			start: year + '-'+ month +'-30',
			color: 'rgba(' + blueRgb + ', .35)'
		}]);
		
		return function cleanUp() {
			context.setAppContentFullHeight(false);
			context.setAppContentClass('');
		}
		
		// eslint-disable-next-line
	}, []);
	
	return (
		<div className="d-flex">
			<div className="w-250px d-lg-block d-none">
				<div className="desktop-sticky-top px-3 py-4">
					<a href="#/" className="btn btn-theme btn-sm d-block mb-3">CREATE EVENT</a>
					<DateTime inputProps={{ placeholder: 'Datepicker' }} input={false} timeFormat={false}  />
					<hr className="my-4" />
					<div className="fc-event-list" id="external-events">
						<div className="fw-semibold small mb-2 mt-n2">Work:</div>
						<div className="fc-event-item"><div className="fc-event-link" data-color="rgba(255, 93, 172, .35)"><i className="fa fa-circle fs-5px me-2 text-pink"></i> Team Meeting</div></div>
						<div className="fc-event-item"><div className="fc-event-link" data-color="rgba(255, 84, 84, .35)"><i className="fa fa-circle fs-5px me-2 text-danger"></i> Project Deadline</div></div>
						<div className="fc-event-item"><div className="fc-event-link" data-color="rgba(255, 169, 38, .35)"><i className="fa fa-circle fs-5px me-2 text-warning"></i> Client Call</div></div>
						<div className="fc-event-item"><div className="fc-event-link" data-color="rgba(255, 241, 68, .35)"><i className="fa fa-circle fs-5px me-2 text-yellow"></i> Presentation</div></div>
						<div className="fc-event-item"><div className="fc-event-link" data-color="rgba(37, 220, 59, .35)"><i className="fa fa-circle fs-5px me-2 text-green"></i> Code Review</div></div>
						<div className="fc-event-item"><div className="fc-event-link" data-color="rgba(0, 255, 156, .35)"><i className="fa fa-circle fs-5px me-2 text-teal"></i> Staff Training</div></div>
						<div className="fc-event-item"><div className="fc-event-link" data-color="rgba(0, 208, 253, .35)"><i className="fa fa-circle fs-5px me-2 text-info"></i> Conference</div></div>
						
						<div className="fw-semibold small mb-2 mt-4">Personal:</div>
						<div className="fc-event-item"><div className="fc-event-link" data-color="rgba(108, 152, 255, .35)"><i className="fa fa-circle fs-5px me-2 text-primary"></i> Holiday</div></div>
						<div className="fc-event-item"><div className="fc-event-link" data-color="rgba(144, 145, 255, .35)"><i className="fa fa-circle fs-5px me-2 text-indigo"></i> Sick Leave</div></div>
						<div className="fc-event-item"><div className="fc-event-link" data-color="rgba(212, 106, 255, .35)"><i className="fa fa-circle fs-5px me-2 text-purple"></i> Breakfast</div></div>
						<div className="fc-event-item"><div className="fc-event-link" data-color="rgba(97, 122, 134, .35)"><i className="fa fa-circle fs-5px me-2 text-gray-500"></i> Lunch</div></div>
						<div className="fc-event-item"><div className="fc-event-link" data-color="rgba(255, 255, 255, 0.75)"><i className="fa fa-circle fs-5px me-2 text-muted"></i> Dinner</div></div>
					</div>
				</div>
			</div>
			<div className="flex-1 p-3 p-lg-4">
				<FullCalendar 
					plugins={plugins}
					initialView="dayGridMonth"
					themeSystem="bootstrap"
					headerToolbar={headerToolbar}
					buttonText={buttonText}
					events={events}
					views={views}
				/>
			</div>
		</div>
	)
}

export default Calendar;